import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './PackageDisplay.module.sass';
import { useHistory, useParams } from 'react-router';
import { CustomerContext } from '../../contexts/CustomerContext';
import Image from "../Image";
import defaultBackground from "../../assets/Package_Blue.png";
import Button from '../Button/v2';
import AbsolutePosImgs from '../_pages/AbsolutePosImgs/AbsolutePosImgs'
import discountedPrice, { money } from '../../utils/offerPricing';
import { routes } from "../../routes";
import axios from 'axios';
import useBuyAllOption from "../../hooks/useBuyAllOption";
import useLocalStorage from "../../hooks/useLocalStorage";
import useAddons from "../../hooks/useAddons";
import usePricelist from "../../hooks/usePricelist";

const PackageDisplay = ({ backgroundUrl, multiPoseHandler, orderPackage, isElementary,
                          studentImageUrl, option, price, imageTypes, currentOrderPackage, packageId,
                          selectedPose, preorderPose, offer }) => {
  const { package_id } = useParams();
  const history = useHistory();
  const { customer, setCustomer } = useContext(CustomerContext);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const { data: pricelist } = usePricelist(packageId);
  const { data: buyAllOption, isLoading: isLoadingBuyAll } = useBuyAllOption(packageId, customer.currentSchool.id);
  const [currentSeason] = useLocalStorage(`currentSeason-${customer?.currentStudent?.id}`)
  const { data: addons } = useAddons(isElementary);

  // Promotional price — SAME engine as the senior flow. `offer` is the coupon resolved by
  // for_landing_page (time-windowed, use_in_order_flow-gated) and threaded down from
  // OptionSelectionContent; discountedPrice returns a "now" price only for PERCENTAGE offers.
  const rawPrice = price?.price;
  const discounted = discountedPrice(rawPrice, offer);

  const handleContinue = async (optionId) => {
    if (optionId === buyAllOption?.id) {
      const response = await axios.post(`/carts/${customer?.cart?.id}/buy_all`,
        { package_id: packageId, option_id: buyAllOption.id, student_id: customer.currentStudent.id, season: currentSeason }
      );

      const orderPackageId = response.data?.order_package_id;

      if ([653, 654, 656, 656].includes(packageId)) return history.push(routes.confirm(orderPackageId))
      if (addons.length === 0 || !orderPackageId) return history.push(routes.review());

      history.push(routes.confirm(orderPackageId))
    } else {
      multiPoseHandler(optionId)
    }
  };

  if (!(option && price)) return null;
  if (isLoadingBuyAll) return null;

  return (
    <>
      <div className={styles.container} onClick={() => multiPoseHandler(option.id)}>
        <div className={styles.upperContainer}>
          <Image src={option.imageUrl.includes('missing') ? defaultBackground : option.imageUrl} alt="" classes={styles.packageImage} />
          {!preorderPose && !pricelist?.hideCss && AbsolutePosImgs(customer, packageId, option)}

        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.packageDescriptionContainer}>
            <div className={styles.innerContainer}>
              <div>
                <p className={styles.description}>
                  {option.name}
                </p>
                {option.tagline && (
                  <p className={styles.description2}>
                    {option.tagline}
                  </p>
                )}
              </div>

              {/* Prices stacked, right-aligned: discounted bold on top, struck regular below.
                  The offer itself is stated once, in the banner — not repeated per card. */}
              <div className={styles.priceRow}>
                <span className={styles.saleprice}>
                  {money(discounted != null ? discounted : rawPrice) || '$0'}
                </span>
                {discounted != null && (
                  <span className={styles.price}>{money(rawPrice)}</span>
                )}
              </div>
            </div>
          </div>

          <div className={styles.packageContents}>
            <p className={styles.packageText}>
              {option.description}
            </p>
          </div>
          <Button
            className={styles.btn}
            onClick={() => handleContinue(option.id)}
          >
            Select
          </Button>
        </div>
      </div>
    </>
  );
};

PackageDisplay.defaultProps = {
  imageTypes: [],
  multiPose: null,
  offer: null,
};

PackageDisplay.propTypes = {
  // Resolved promotional offer coupon (from useOfferCoupon) — drives the per-card
  // "Was $X / Coupon: CODE". Null when no offer is live for this pricelist.
  offer: PropTypes.shape({
    code: PropTypes.string,
    couponType: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  backgroundUrl: PropTypes.string,
  studentImageUrl: PropTypes.string,
  multiPose: PropTypes.func,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    abbreviation: PropTypes.string,
    poses: PropTypes.number,
    slug: PropTypes.string,
    name: PropTypes.string.isRequired,
    bestValue: PropTypes.bool.isRequired,
    additionalPoseCharge: PropTypes.number,
    download: PropTypes.bool.isRequired,
    emailPicture: PropTypes.bool.isRequired,
    superValue: PropTypes.bool.isRequired,
    without: PropTypes.bool.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }),
  imageTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  price: PropTypes.shape({
    id: PropTypes.string.isRequired,
    begin: PropTypes.string,
    enddate: PropTypes.string,
    price: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  })
};

export default PackageDisplay;
